import { useLockersContext } from "../contexts/LockersContext";
import { useSpecificLockerActionContext } from "../contexts/SpecificLockerActionContext";
import { FavouriteLocker as IFavouriteLocker, Locker } from "../data/LockerDataTypes";
import { getOrderedFavouriteLockerTypes } from "../services/favouriteLockersService";
import LockerListItem from "./lockerItem/LockerListItem";

const LockerList = () => {
    const { lockerResponse } = useLockersContext();
    const { favouriteLockers, previouslyUsedLockers } = useSpecificLockerActionContext();

    const sortLockerResponse = (): Locker[] => {
        const favoriteLockers: Locker[] = getFavouriteLockersListOrdered();
        const prevUsedLockers: Locker[] = getPrevUsedLockersList();

        const prevUsedLockersWithoutFavs = prevUsedLockers.filter(el => {
            return !favoriteLockers.includes(el);
        });

        const specialLockersList: Locker[] = favoriteLockers.concat(prevUsedLockersWithoutFavs);

        const commonLockersList = lockerResponse.filter(el => {
            return !specialLockersList.includes(el);
        });

        return specialLockersList.concat(commonLockersList);
    }

    const getPrevUsedLockersList = (): Locker[] => {
        const prevLockers: Locker[] = [];

        previouslyUsedLockers.forEach((item) => {
            const lockerFound = lockerResponse.find(x => x.lockerId == item?.lockerId);
            if (lockerFound) {
                prevLockers.push(lockerFound);
            }
        })

        return prevLockers;
    }

    const convertFavouriteLockerToLocker = (favouriteLocker: IFavouriteLocker): Locker | undefined => {
        let localStorageFavouriteLocker = favouriteLockers.find(x => x.type == favouriteLocker.type);
        return lockerResponse.find(x => x.lockerId == localStorageFavouriteLocker?.lockerId);
    }

    const getFavouriteLockersListOrdered = (): Locker[] => {
        const favoriteLockers: Locker[] = [];

        if (favouriteLockers?.length == 0) {
            return favoriteLockers;
        }

        getOrderedFavouriteLockerTypes().forEach(item => {
            const lockerDetails = convertFavouriteLockerToLocker(item)
            if (lockerDetails) {
                favoriteLockers.push(lockerDetails)
            }
        })

        return favoriteLockers;
    }
    return (
        <ul className="list-group">
            { sortLockerResponse()
                .map((locker: Locker, index: number) => <LockerListItem locker={locker} key={index} />)
            }
        </ul>
    );
}

export default LockerList;